/* src/app/components/doc-viewer-new/form-controls/text-input/text-input.component.scss */
.form-container {
  display: flex;
  flex-direction: column;
}
.form-container > label {
  color: #3949AB;
  font-weight: 500;
  display: block;
  margin-bottom: 2px;
}
:host-context(.dark-theme) .form-container > label {
  color: #FFC107;
  font-weight: 400;
}
.input-container {
  display: flex;
  flex-direction: row;
  border: 1px solid #565656;
  border-radius: 5px;
  align-items: center;
  outline: transparent solid 0px;
  transition: outline 200ms ease-in-out;
}
.input-container .divider {
  border-right-color: rgba(86, 86, 86, 0.74);
  border-left-color: transparent;
  border-right-width: 1px;
  border-left-width: 1px;
  border-right-style: solid;
  border-left-style: solid;
  transition: border-color 200ms ease-in-out;
}
.input-container:hover {
  border: 1px solid #7a7a7a;
  outline: #7a7a7a solid 1px;
}
.input-container:hover .divider {
  border-color: rgb(122, 122, 122);
}
.input-container > input,
textarea {
  width: 100%;
  appearance: none;
  outline: none;
  border: none;
  padding: 0;
  margin-left: 12px;
  background: inherit;
  color: inherit;
}
.input-container:focus-within {
  border: 1px solid rgb(36, 62, 144);
  outline: rgb(36, 62, 144) solid 1px;
}
.input-container:focus-within .divider {
  border-color: rgb(36, 62, 144);
}
.input-container:focus-within input,
.input-container:focus-within textarea {
  caret-color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .input-container:focus-within {
  border: 1px solid #FFC107;
  outline: #FFC107 solid 1px;
}
:host-context(.dark-theme) .input-container:focus-within .divider {
  border-color: #FFC107;
}
:host-context(.dark-theme) .input-container:focus-within input,
:host-context(.dark-theme) .input-container:focus-within textarea {
  caret-color: #FFC107;
}
.disabled {
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: rgba(0, 0, 0, 0.55);
  background: #fafafa;
}
.disabled .divider {
  border-color: rgba(0, 0, 0, 0.15);
}
.disabled:hover {
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.disabled:hover .divider {
  border-color: rgba(0, 0, 0, 0.15);
}
:host-context(.dark-theme) .disabled {
  border: none;
  color: rgba(255, 255, 255, 0.35);
  background: #373737;
}
:host-context(.dark-theme) .disabled .divider {
  border-color: none;
}
:host-context(.dark-theme) .disabled:hover {
  outline: none;
  border: none;
}
:host-context(.dark-theme) .disabled:hover .divider {
  border-color: none;
}
/*# sourceMappingURL=text-input.component.css.map */
